// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 797) return "css/core.797.87d1efa0f7d6e30e85e0.main.css";
	if (chunkId === 179) return "css/core.main.1eddc9bdc4e53412e614.main.css";
	// return url for filenames based on template
	return "css/core.chunk." + {"172":"bot","367":"es-json","405":"cfd"}[chunkId] + "." + {"172":"402edf283f3cb6f1753c","367":"d734d6b71af78c922420","405":"fc559ec00b7435aaa806"}[chunkId] + ".css";
};